// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qORnD","from":"styles_from__3E2UQ","label":"styles_label__kXqmc","to":"styles_to__Tt55n","currency":"styles_currency__mbDmK"};